import { useEffect, useState } from "react";

/** Returns true while the browser tab is visible, so consumers can pause polling in background tabs. */
export default function useDocumentVisible(): boolean {
  const [visible, setVisible] = useState(document.visibilityState !== "hidden");

  useEffect(() => {
    const handleVisibilityChange = () => setVisible(document.visibilityState !== "hidden");
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  return visible;
}
